import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditOrderModal = ({ isEditModalOpen, toggleModal, orderId, fetchOrders }) => {
  // State to hold form values
  const [customerName, setCustomerName] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");
  const [shippingAddress, setShippingAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [fetchingData, setFetchingData] = useState(false);
  const [products, setProducts] = useState("");
  const [paymentIntentId, setPaymentIntentId] = useState(""); // State for payment intent ID
  const [orderDate,setOrderDate]= useState("");
  // Define order statuses for the dropdown
  const statuses = ["Pending", "Shipped", "Delivered", "Canceled"];

  // Fetch the order details when modal opens
  useEffect(() => {
    if (isEditModalOpen && orderId) {
      console.log(`Fetching details for order ID: ${orderId}`);
      fetchOrderDetails(orderId);
    }
  }, [isEditModalOpen, orderId]);

  const fetchOrderDetails = async (orderId) => {
    setFetchingData(true);
    try {
      console.log("Fetching order details...");
      const response = await axios.get(`https://api.theonlysale.com/api/order/get/${orderId}`);
      console.log("response.data", response.data);
      if (response.status === 200) {
        const order = response.data;
        console.log("Order details fetched:", order);

        setCustomerName(order.name || "");
        setOrderStatus(order.status || "");
        setTotalAmount(order.totalAmount || "");
        setShippingAddress(order.address || "");
        setOrderDate(order.orderDate ? new Date(order.orderDate).toISOString().split('T')[0] : "");
        setDeliveryDate(order.arrivalDate ? new Date(order.arrivalDate).toISOString().split('T')[0] : "");
        setNotes(order.notes || "");
        setPostalCode(order.postalCode || "");
        setEmail(order.email || "");
        setCity(order.city || "");
        
        // If the order has products, ensure they are fetched too
        setProducts(order.product || []); // Save this to include in the update payload
        
        // Set payment intent ID if available
        setPaymentIntentId(order.paymentIntentId || ""); // Assuming the order object has paymentIntentId
      } else {
        toast.error("Failed to fetch order details");
      }
    } catch (error) {
      console.error("Error fetching order details:", error);
      toast.error("Error fetching order details");
    } finally {
      setFetchingData(false);
      console.log("Fetching order details completed");
    }
  };

  const handleEditOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Handling order edit...");
  
    try {
      if (orderStatus === "Delivered" && paymentIntentId) {
        console.log("Capturing payment for paymentIntentId:", paymentIntentId);
        const captureResponse = await axios.post(`https://api.theonlysale.com/api/pay/capture-payment`, {
          paymentIntentId: paymentIntentId,
        });
  
        if (captureResponse.status !== 200) {
          toast.error("Failed to capture payment.");
          return;
        }
      }
  
      // Prepare the product data for the request
      const productData = products.map((product) => ({
        id: product.id,
        quantity: product.OrderProduct.quantity, // Adjust as necessary
      }));
  
      // Make the API call to update the order status
      console.log("Updating order status...");
      const response = await axios.put(`https://api.theonlysale.com/api/order/update/status/${orderId}`, {
        status: orderStatus, // Use the status from the dropdown
        products: productData, // Include products in the request body
      });
  
      if (response.status >= 200 && response.status < 300) {
        toast.success("Order status updated successfully");
        fetchOrders(); // Refetch the orders list to show updated data
        toggleModal(); // Close the modal
      } else {
        toast.error("Failed to update order status. Please try again.");
      }
    } catch (error) {
      console.error("Error updating order status:", error.response ? error.response.data : error.message);
      toast.error("Failed to update order status. Please try again.");
    } finally {
      setLoading(false);
      console.log("Order edit handling completed");
    }
  };
  

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      console.log("Overlay clicked, closing modal...");
      toggleModal();
    }
  };
  console.log("produkti",products)
  return (
    <>
      <ToastContainer />
      {isEditModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50"
          onClick={handleOverlayClick}
        >
          <div className="relative w-full max-w-2xl p-4 max-h-full">
            <div className="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
              <div className="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  {fetchingData ? "Loading..." : "Edit Order"}
                </h3>
                <button
                  type="button"
                  onClick={toggleModal}
                  className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                >
                  <i className="fa fa-times w-5 h-5"></i>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              {fetchingData ? (
                <p>Loading order details...</p>
              ) : (
                <form onSubmit={handleEditOrder}>
                  {/* Products Section */}
                  {products.length > 0 ? (
  <div className="mb-4">
    <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-2">Products</h4>
    <ul className="flex flex-wrap gap-4">
      {products.map((product, index) => (
        <li
          key={index}
          className="p-2 bg-gray-100 dark:bg-gray-700 rounded-lg w-48 flex-shrink-0"
        >
          <div className="font-medium text-gray-800 dark:text-white">{product.name}</div>
          <div className="text-sm text-gray-600 dark:text-gray-300">
            <p>Quantity: {product.OrderProduct.quantity}</p>
            <p>Price: ${product.price}</p>
            <p>Type: {product.type}</p>
            <p>Details: {product.details}</p>
          </div>
          {product.images && (
            <img
              src={`https://api.theonlysale.com/${JSON.parse(product.images)[0]}`}
              alt={product.name}
              className="w-24 h-24 mt-2 rounded"
            />
          )}
        </li>
      ))}
    </ul>
  </div>
) : (
  <p className="mb-4 text-gray-500 dark:text-gray-400">No products available for this order.</p>
)}



                  {/* The rest of the form fields */}
                  <div className="grid gap-4 mb-4 sm:grid-cols-2">
                    {/* Order ID (non-editable) */}
                    <div>
                      <label htmlFor="order_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Order ID
                      </label>
                      <input
                        type="text"
                        name="order_id"
                        id="order_id"
                        value={orderId}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Customer Name (non-editable) */}
                    <div>
                      <label htmlFor="customer_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Customer Name
                      </label>
                      <input
                        type="text"
                        name="customer_name"
                        id="customer_name"
                        value={customerName}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Order Status (editable) */}
                    <div>
                      <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Order Status
                      </label>
                      <select
                        id="status"
                        value={orderStatus}
                        onChange={(e) => setOrderStatus(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        required
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        {statuses.map((status) => (
                          <option key={status} value={status}>
                            {status}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Total Amount (non-editable) */}
                    <div>
                      <label htmlFor="total_amount" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Total Amount
                      </label>
                      <input
                        type="number"
                        name="total_amount"
                        id="total_amount"
                        value={totalAmount}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>
      {/* Delivery Date (non-editable) */}
      <div>
                      <label htmlFor="order_date" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Order Date
                      </label>
                      <input
                        type="date"
                        name="order_date"
                        id="order_date"
                        value={orderDate}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>
                    {/* Delivery Date (non-editable) */}
                    <div>
                      <label htmlFor="delivery_date" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Delivery Date
                      </label>
                      <input
                        type="date"
                        name="delivery_date"
                        id="delivery_date"
                        value={deliveryDate}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Shipping Address (non-editable) */}
                    <div>
                      <label htmlFor="shipping_address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Shipping Address
                      </label>
                      <textarea
                        name="shipping_address"
                        id="shipping_address"
                        value={shippingAddress}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Postal Code (non-editable) */}
                    <div>
                      <label htmlFor="postal_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Postal Code
                      </label>
                      <input
                        type="text"
                        name="postal_code"
                        id="postal_code"
                        value={postalCode}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Email (non-editable) */}
                    <div>
                      <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        id="email"
                        value={email}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* City (non-editable) */}
                    <div>
                      <label htmlFor="city" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        value={city}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>

                    {/* Notes (non-editable) */}
                    <div className="col-span-2">
                      <label htmlFor="notes" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Notes
                      </label>
                      <textarea
                        name="notes"
                        id="notes"
                        value={notes}
                        disabled
                        className="bg-gray-100 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end space-x-2">
                    <button
                      type="submit"
                      disabled={loading}
                      className="inline-flex items-center px-5 py-2.5 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                    >
                      {loading ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );

};

export default EditOrderModal;
